export default import.meta.ROLLDOWN_FILE_URL_Kc$_rXh932YpZ9rGVnRe5g